<template>
  <transition name="fade">
    <div
      v-show="showScrollTop"
      class="scroll-top"
      @click="scrollTop"
    >
      <icon name="arrow_upward" />
    </div>
  </transition>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    isSidePanel: Boolean,
  },

  data() {
    return {
      showScrollTop: false,
    };
  },

  mounted() {
    this.scrollElement.addEventListener('scroll', this.checkScroll);
  },

  destroyed() {
    this.scrollElement.addEventListener('scroll', this.checkScroll);
  },

  computed: {
    scrollElement() {
      return this.isSidePanel ? document.querySelector('#side-panel') : window;
    },
  },

  methods: {
    checkScroll() {
      const scrollTop = this.isSidePanel ? this.scrollElement.scrollTop : Math.max(document.body.scrollTop, document.documentElement.scrollTop);

      if (scrollTop > 1000) {
        this.showScrollTop = true;
      } else {
        this.showScrollTop = false;
      }
    },

    scrollTop() {
      this.scrollElement.scroll(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.scroll-top {
  @include circle(50px);
  background-color: var(--theme-background);
  box-shadow: $elevation-1;
  position: fixed;
  bottom: $gp;
  z-index: 1;
  cursor: pointer;

  @media($medium-down) {
    @include circle(40px);
  }
}
</style>
